<template>
    <span class="text-danger" v-if="mostrarBtnExcluir">
        <i
            class="fa fa-trash fa-lg icon-button ml-1"
            title="Excluir Mensagem"
            @click.stop="confirmarExcluir()"
        ></i>
    </span>
</template>

<script>
import MensagensServicos from './MensagensServicos'

export default {
    props: {
        mensagem: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Exclusão de Mensagem',
                html: `Confirma a exclusão da mensagem <b>${this.mensagem.assunto}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            MensagensServicos.excluirMensagem(this.mensagem.mensagemId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Mensagem excluída com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterMensagensAtualizadas')
                        } else {
                            this.$toast.error(
                                'Erro ao excluir mensagem.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    },

    computed: {
        mostrarBtnExcluir() {
            return this.mensagem.status == 0
        }
    }
}
</script>
